<template>
  <div class="profile__avatar profile__card">
    <Avatar size="xl" @click.native="onFileInputOpen" />

    <div class="profile__avatar-upload">
      <h6 class="profile__subtitle">
        Imagem do perfil
        <span>(Recomendado 800x800)</span>
      </h6>
      <input
        ref="fileInput"
        type="file"
        accept=".png, .jpg, .jpeg"
        @change="onFileSelect"
      />
      <button class="button4" @click.prevent="onFileInputOpen">
        Fazer upload
      </button>
      <button class="button4" @click.prevent="openModalPhoto()">
        Usar Webcam
      </button>
      <button class="button4" @click.prevent="updatePhoto()">
        Atualizar foto
      </button>
      <p class="error-form-msg" v-if="errorMessages.length">
        {{ showEnrollError }}
        <BIconX @click="onCloseErrorMessage" />
      </p>
    </div>

    <BModal id="takePhoto" ref="takePhoto" hide-footer centered>
      <div>
        <div>
          <video
            ref="camera"
            id="preview"
            width="100%"
            height="auto"
            autoPlay
          />
          <button @click.prevent="takePhoto()" class="button2">
            Tirar Foto
          </button>
        </div>
      </div>
    </BModal>
  </div>
</template>

<script>
import Compressor from "compressorjs";
import Avatar from './Avatar';

export default {
  name: "AvatarForm",
  components: {
    Avatar
  },
  data() {
    return {
      oldPhoto: "",
      newPhoto: "",
      hasUpdated: false,
      canSendNewPhoto: false,
      errorMessages: [],
      camera: {
        blob: null,
        devices: [],
        constraints: {},
        selected: null
      }
    };
  },
  mounted() {
    this.oldPhoto = this.$store.state.user.currentUser.photo;
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      this.stopCam();
    });
  },
  methods: {
    onFileSelect(event) {
      this.createBase64File(event.target.files[0]);
    },
    onFileInputOpen() {
      this.$refs.fileInput.click();
    },
    createBase64File(file) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.oldPhoto = this.$store.state.user.currentUser.photo;
        this.newPhoto = reader.result;
      };
    },
    openModalPhoto() {
      this.$bvModal.show("takePhoto");
      setTimeout(() => {
        this.openCam();
      }, 5);
    },
    takePhoto() {
      let that = this;

      navigator.mediaDevices.getUserMedia({ video: true }).then(mediaStream => {
        const track = mediaStream.getVideoTracks()[0];
        let imageCapture = new ImageCapture(track);
        imageCapture.takePhoto().then(blob => {
          const compressor = new Compressor(blob, {
            quality: 0.2,
            height: 540,
            width: 960,
            success(result) {
              var reader = new FileReader();
              reader.readAsDataURL(result);
              reader.onloadend = function() {
                that.stopCam();
                that.newPhoto = reader.result;
                that.needValidatePhoto = true;
                that.$bvModal.hide("takePhoto");
              };
            }
          });
        });
      });
    },
    openCam() {
      const constraints = { video: { width: 555, height: 367 } };
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function(mediaStream) {
          const video = document.querySelector("video");
          video.srcObject = mediaStream;
          video.onloadedmetadata = function(e) {
            video.play();
          };
        });
    },
    stopCam() {
      if (this.$refs.camera && this.$refs.camera.srcObject) {
        this.$refs.camera.srcObject.getTracks().forEach(function(track) {
          track.stop();
        });

        this.camera = {
          blob: null,
          devices: [],
          constraints: {},
          selected: null
        };
      }
    },
    photoFallback() {
      return (
        this.$store.state.user.currentUser.photo ||
        require("./../assets/images/doctor-img.jpg")
      );
    },
    onCloseSuccessMessage() {
      this.hasUpdated = false;
    },
    onCloseErrorMessage() {
      this.errorMessages = [];
    },
    async updatePhoto() {
      if (!this.hasANewPhoto) return;

      return this.updateNewPhoto();
    },
    imageEnroll() {
      this.$store
        .dispatch("faceRecognition/imageEnroll", { image: this.newPhoto })
        .then(() => {
          this.updateNewPhoto();
        })
        .catch(error => {
          this.hasError = true;
          this.errorMessages = error.response.data.errors;
          this.newPhoto = this.oldPhoto;
        });
    },
    updateNewPhoto() {
      const payload = {
        id: this.$store.state.user.currentUser.id,
        photo: { data: this.newPhoto }
      };
      this.$store.dispatch("user/updateUser", payload).then(() => {
        this.hasUpdated = true;
        this.canSendNewPhoto = false;
      });
    }
  },
  computed: {
    hasANewPhoto() {
      return this.newPhoto != "" && this.newPhoto != this.oldPhoto;
    },
    userPhoto() {
      return `background: url(${this.oldPhoto});`;
    },
    showEnrollError() {
      switch (this.errorMessages[0].code) {
        case "0002":
          return "Nenhum rosto encontrado da imagem enviada.";
          break;
        case "0003":
          return "Imagem não pode ser vazia";
          break;
        default:
          return "Erro na imagem. Favor tentar outra imagem.";
          break;
      }
    }
  }
};
</script>

<style></style>
